'use client';
import dynamic from 'next/dynamic';

export const TrackingManagerLazy = dynamic(() => import('./tracking-manager').then((mod) => mod.TrackingManager), {
    ssr: false
});
